import { create } from 'zustand'
import type { User, AuthTokens } from '../types'
import { authApi } from '../services/api-client'

interface AuthState {
  user: User | null
  tokens: AuthTokens | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  setAuth: (user: User, tokens: AuthTokens) => void
  clearAuth: () => void
  logout: () => Promise<void>
  checkAuth: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  tokens: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,

  setAuth: (user, tokens) => {
    localStorage.setItem('access_token', tokens.access)
    localStorage.setItem('refresh_token', tokens.refresh)
    set({
      user,
      tokens,
      isAuthenticated: true,
      isLoading: false,
      error: null,
    })
  },

  clearAuth: () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    set({
      user: null,
      tokens: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,
    })
  },

  logout: async () => {
    try {
      await authApi.logout()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      get().clearAuth()
    }
  },

  checkAuth: async () => {
    const accessToken = localStorage.getItem('access_token')
    if (!accessToken) {
      set({ isLoading: false, isAuthenticated: false })
      return
    }

    try {
      const user = await authApi.getCurrentUser()
      const access = localStorage.getItem('access_token') || ''
      const refresh = localStorage.getItem('refresh_token') || ''
      set({
        user,
        tokens: { access, refresh },
        isAuthenticated: true,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      get().clearAuth()
    }
  },
}))
